import React from 'react';
import { fleetPanelData } from './fleetPanelData';
import { moduleSummary } from './componentProfileData';

const devices = n => `${n} device${n === 1 ? '' : 's'}`;

/**
 * The fleet picture, as two more cards in the project's existing stats row.
 *
 * Deliberately not a panel of its own. The project view already answers
 * "what am I looking at" with a row of stat cards, and the fleet's baseline
 * and module count are the same kind of fact; giving them their own bordered
 * box above the row would have said they were a different kind.
 *
 * Renders nothing for a project without a snapshot — an ordinary project must
 * look exactly as it did before this epic.
 */
const InventoryFleetStats = ({ project }) => {
  const fleet = fleetPanelData(project);
  if (!fleet) return null;

  const modules = moduleSummary(project);

  return (
    <>
      <div className="bst-stat-card">
        <div className="bst-stat-label">Inventory Baseline</div>
        <div className="bst-stat-value">{fleet.baseline || '—'}</div>
        <div
          className="bst-stat-subtext"
          title={fleet.versions.map(v => `${v.version}: ${devices(v.ciCount)}`).join('\n')}
        >
          {fleet.matchingCount} of {devices(fleet.totalCis)} match
          {fleet.inconsistentCount > 0 && <> · {fleet.inconsistentCount} on another version</>}
        </div>
      </div>

      {modules && (
        <div className="bst-stat-card">
          <div className="bst-stat-label">Modules in Use</div>
          <div className="bst-stat-value">
            {modules.enabled} of {modules.total}
          </div>
          <div className="bst-stat-subtext">{devices(modules.configuredCiCount)} reported config</div>
        </div>
      )}
    </>
  );
};

export default InventoryFleetStats;
